module.exports = __webpack_public_path__ + "static/media/caret-right@3x.3233ba34.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Icons/caret-right@3x.png
// module id = 822
// module chunks = 2